import { Grid, SxProps, Typography } from '@mui/material'
import { isNil } from 'lodash'
import React from 'react'

interface ErrorLabelProps {
  label: string | React.ReactNode
  sx?: SxProps
}

export const ErrorLabel: React.FC<ErrorLabelProps> = ({ label, sx }) => {
  if (isNil(label) || label === '') {
    return null
  }

  return (
    <Grid container direction='row' flexWrap='nowrap' sx={sx}>
      <Grid item sx={{ minWidth: '5px', backgroundColor: 'error.main' }} />
      <Grid
        item
        sx={{
          pl: '10px !important',
          pr: '10px !important',
          pt: '5px !important',
          pb: '5px !important',
          backgroundColor: 'flareSecondary.main'
        }}
      >
        <Typography
          sx={{
            fontSize: '12px !important',
            fontWeight: '600 !important',
            color: 'text.primary',
            lineHeight: '16px !important',
            letterSpacing: 'normal !important'
          }}
        >
          {label}
        </Typography>
      </Grid>
    </Grid>
  )
}
